export default __webpack_public_path__ + "static/media/notification_orange.4135686d.svg";